// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"470":"15969021","805":"00000ef7","964":"f41927d0"}[chunkId] + ".chunk.css";
};